/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Listaspectcontainsoraspect13Inputs */

const de__class_listaspectcontainsoraspect13 = /** @type {(inputs: _Class_Listaspectcontainsoraspect13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`beinhaltet eins von`)
};

/**

* @param {_Class_Listaspectcontainsoraspect13Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_listaspectcontainsoraspect13 = /** @type {((inputs?: _Class_Listaspectcontainsoraspect13Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Listaspectcontainsoraspect13Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_listaspectcontainsoraspect13(inputs)
});
export { _class_listaspectcontainsoraspect13 as "_class_ListAspectCONTAINSORAspect" }